import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/press")({
	beforeLoad: () => {
		throw redirect({
			href: "https://www.dropbox.com/scl/fo/6d506yts27y7bbkhfoiln/AMmX1_BbLlYfnqoL0b2xtuc?rlkey=uaaoqeqnsjolt8gpxhejx0114&st=jth4hkus&dl=0",
		});
	},
});
